import * as React from 'react'
import * as moment from 'moment'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { withToast } from 'src/shared/Toast'
import { WithToast } from 'src/shared/Toast/Toast'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { ExpensionStepProps } from 'src/shared/ExpensionStepper'
import { RouteComponentProps, withRouter } from 'react-router'
import { Typography, Theme, createStyles, WithStyles, withStyles, ListItem, ListItemText, ListItemSecondaryAction, Checkbox, List } from '@material-ui/core'
import TunnelActions from 'src/shared/TunnelActions/TunnelActions'
import { MediaCard } from 'src/shared/MediaCard/MediaCard'
import { getUserBestName } from 'src/shared/utils/helpers'
import CotationGauge from 'src/shared/Gauge/CotationGauge'
import { createCotation, getUsersToNotify, updateCotation } from 'src/core/redux/action/cotationAction'
import { formDataType } from '../../../../../shared/Cotation/form/CotationData'
import { Id } from 'src/type/basics'
import { CtxCotationRequest, withCotationRequest } from '../CotationRequestProvider'
import { questionsOptional } from 'src/shared/Gauge/QuestionOptional'
import SummaryContext from 'src/shared/Cotation/summary/SummaryContext'

const styles = (t: Theme) => createStyles({
  gaugeWpr: {
    width: '100%',
  }
});

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  WithStyles<typeof styles>,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>, 
  ExpensionStepProps,
  CtxCotationRequest{
    data: any;
    closeRequest: () => void
}

interface UserNotify{
  id: Id;
  name: string;
  email: string;
  phone: string;
  isSelected: boolean;
}

interface IStates{
  usersToNotify: UserNotify[];
  isSelectAll: boolean;
}

class CotationSummaryStep extends React.Component<IProps, IStates> {
  state = {
    usersToNotify: [] as UserNotify[],
    isSelectAll: false
  }

  render() {
    const {t,classes,connectedUser,enterprise, formParams, productSelected} = this.props
    const {usersToNotify} = this.state

    return (
      <>
          {formParams &&
                <>    
                  <MediaCard icon="person">
                    <Typography variant="body1" gutterBottom>{t.requester}</Typography>
                    <Typography variant="body2">
                      <span style={{fontWeight: 'bold'}}>{t.Cotation_summary_request_initial_by}</span>
                      {getUserBestName(connectedUser)}
                    </Typography>
                    <Typography variant="body2">
                      <span style={{fontWeight: 'bold'}}>{t.client} : </span>
                      {enterprise.name}
                    </Typography>
                  </MediaCard>

                  <br /><br />
                  
                  {productSelected && formParams &&
                    <SummaryContext 
                      {...{formParams}}
                      productType={productSelected.product_type}
                      firstLabel={t.Cotation_user_settings}
                      showSaleValue={false}
                    />
                  }

                  <br /><br />

                  
                    <MediaCard icon="network_check">
                      <Typography variant="body1" gutterBottom>{t.Cotation_summary_request_quote_gauge}</Typography>
                        <div className={classes.gaugeWpr}>
                          <CotationGauge gauge={this.generateGauge()} />
                        </div>
                    </MediaCard>

                  <br /><br />

                  <MediaCard icon="add_alert">
                    <Typography variant="body1" gutterBottom>{t.notification}</Typography>
                    <Typography variant="body2">
                      <span style={{fontWeight: 'bold'}}>{t.Cotation_summary_person_to_notify}</span>
                    </Typography>

                    {usersToNotify.length > 0 &&
                      <List dense={false}>
                        {usersToNotify.map(r => (
                            <ListItem 
                                key={`item-${r.id}`} 
                                button
                                disabled={r.id === connectedUser.id ? true : false}
                            >
                                <ListItemText key={`itemtext-${r.id}`} primary={
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        {r.name} - {r.email}
                                    </div>
                                } />
                                
                                <ListItemSecondaryAction key={`action-${r.id}`}>
                                    <Checkbox
                                        key={`checkbox-${r.id}`}
                                        onChange={(e) => this.handleToogleUserSelected(r.id, r.isSelected)}
                                        checked={r.isSelected}
                                        disabled={r.id === connectedUser.id ? true : false}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                      </List>
                    }

                  </MediaCard>
                  
                  <TunnelActions
                      {...this.props}
                      onClick={this.terminate}
                      canNext={true}
                  />
              </>
          }
        </>
    )
  }

  componentDidMount(){
    const {match, toastError, connectedUser} = this.props
    const {usersToNotify} = this.state
    this.props.getUsersToNotify(match.params.productType).then(res => {
      res.data.map(u => {
        usersToNotify.push({id: u.id, name: getUserBestName(u), email: u.email, phone: u.phone, isSelected: u.id === connectedUser.id ? true : false })
      })
    }).catch(err => toastError(err.msg))
  }

  @autobind
  private generateGauge(){
    const {productSelected, formParams} = this.props
        const q = questionsOptional[productSelected ? productSelected.product_type : ''].questionsOptional
        if(q && q.length > 0){
          let count = 0;
          q.map(question => {
            if(!formParams[question]){
              count++;
            }
          })

          switch(q.length - count){
            case 0: 
              return "red";
            case q.length - 1:  // only 1 unfilled 
              return "yellow";
            case q.length:
              return "green";
            default: 
              return "orange"
          }

        } else {
          return undefined
        }
      
  }

  toggleSelectAll = e => {
    this.setState({isSelectAll: !this.state.isSelectAll})
    const clone = this.state.usersToNotify
    clone.map(r => r.isSelected = !this.state.isSelectAll);
    this.setState({usersToNotify: clone})
  }

  handleToogleUserSelected = (id, selected) => {
    const index = this.state.usersToNotify.findIndex(u => u.id === id);
    const clone = this.state.usersToNotify.slice(0);
    clone[index].isSelected = !selected
    this.setState({usersToNotify: clone})
  }

  getIdsUsersToNotify = (users: any) => {
    return users.filter(r => r.isSelected === true).map(d => d.id).join()
  }

  @autobind
  private terminate(){
    const {t, promisesWithProgress, toastError, toastSuccess, enterprise, product, match, location, formParams} = this.props
    const usersTemp = this.getIdsUsersToNotify(this.state.usersToNotify)
    
    const formData = {...formParams}
    if(usersTemp && usersTemp.length > 0){
      formData['cotation'] = {
        users_to_notify_ids: usersTemp
      }
    }
    formDataType[product.product_type].map(d => {
      if(formData[d.value] !== undefined && formData[d.value] !== null){  // Do not use !!, in case data is 0 => always false
        if(d.type === 'date' && !!formData[d.value]){
          formData[d.value] = moment(formData[d.value]).format()
        }
        if(d.type === 'number'){
          formData[d.value] = parseFloat(formData[d.value])
        }
      } else {
        delete formData[d.value]
      }
    })

    if(location && location.state && location.state.duplicate){
      promisesWithProgress(
        this.props.updateCotation(formData, match.params.productType, location.state.data.id).then(() => {
          toastSuccess(t.cotation_request.request_success)
          this.props.history.push(`/ptf/enterprise/${enterprise.id}/cotations`)
        }).catch(err => toastError(err.msg))
      )
    } else {
      promisesWithProgress(
        this.props.createCotation(formData, match.params.productType).then(res => {
          toastSuccess(t.cotation_request.request_success)
          this.props.history.push(`/ptf/enterprise/${enterprise.id}/product-detail/${match.params.productType}`)
        }).catch(err => {
          toastError(err.msg)
        })
      )
    }
  }
  
}

const state2props = (state: RootState) => ({
  connectedUser: state.accountInfo.connectedUser,
  enterprise: state.accountInfo.enterpriseSelected,
  product: state.productDetail.entity
})

const dispatch2props = (dispatch: any) => ({
  createCotation: (data: any, productType: string) => dispatch(createCotation(data, productType)),
  updateCotation: (data: any, productType: string, id: string)  => dispatch(updateCotation(data, productType, id)),
  getUsersToNotify: (productType: string) => dispatch(getUsersToNotify(productType))
})

export default compose(
    withI18n,
    withGlobalProgress,
    withRouter,
    withToast,
    withCotationRequest,
    withStyles(styles),
    connect(state2props, dispatch2props),
)(CotationSummaryStep)



// WEBPACK FOOTER //
// ./src/page/Consumer/Product/cotation/step/CotationSummaryStep.tsx